export const toUpper = (arr) => arr.map((item) => item.toUpperCase());
